<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_ptb0lr24 s_bf">
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">
          <a-button size='small' @click="()=>{$router.go(-1)}" class="mr10">
            <LeftOutlined />返回
          </a-button>
          订单操作
        </p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35 s_fonts16"><span class="m-r-15">订单状态：{{orderData.order_status_text}}</span><span>订单号：{{orderData.order_sn}}（{{orderData.delivery_type_text}}）</span>
            <a-button type="link" @click='getRemarks'>修改备注</a-button>
          </p>
          <div class="s_flex_ali m-t-20" v-if='orderData.buyer_remark'>
            买家订单备注：{{orderData.buyer_remark}}
          </div>
          <div class="s_flex_ali m-t-20" v-if='orderData.buyer_remark'>
            卖家订单备注：{{orderData.bussiness_remark}}
          </div>
          <div v-if="orderData.order_status==1&&orderData.to_seller_id==0" class="m-t-10">
            <a-button type="primary" class="m-r-10" @click="orderDeliver(orderData,3)">发货</a-button>
          </div>
        </div>
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">订单详情</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">卖家信息：{{orderData.dealer_name}}</p>
          <p class="s_c333  s_lin_h35">买家信息：{{orderData.buyer_name}}</p>
          <p class="s_c333  s_lin_h35">
            收货信息：{{orderData.name}}，{{orderData.mobile}}，{{orderData.address}}</p>
          <p class="s_c333  s_lin_h35">下单时间：{{orderData.create_time}}</p>
          <p class="s_c333  s_lin_h35" v-if="orderData.confirm_time">发货时间：{{orderData.confirm_time}}</p>
          <p class="s_c333  s_lin_h35" >发货方式: {{orderData.delivery_type_text }}</p>
          <p class="s_c333  s_lin_h35" v-if="orderData.shipping_name">物流公司：{{orderData.shipping_name}}</p>
          <p class="s_c333  s_lin_h35" v-if="orderData.shipping_code">物流单号: {{orderData.shipping_code}}</p>
          <p class="s_c333  s_lin_h35" v-if="orderData.confirm_time">收货时间：{{orderData.confirm_time}}</p>
          <p class="s_c333 s_fonts14  m-b-20">商品清单</p>
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columnsGood' :data-source='orderData.order_goods'>
            <template v-slot:good="{ record }">
              <a-card-meta>
                <template #avatar>
                  <img :src="info.picdomain+'/'+(record.goods_image)" alt="" style="width:50px">
                </template>
                <template #description>
                  <p class="s_omit">{{record.goods_name}}</p>
                </template>
              </a-card-meta>
            </template>
            <template v-slot:product_price="{ record }">
              <p>￥{{record.product?record.product.product_price : '-'}}<span v-if="$route.query.order_type == 'point'">+{{record.product.point}}积分</span></p>
            </template>
            <template v-slot:coupon_price="{ record }">
              <p>{{record.coupon_price || '-'}}</p>
            </template>
            <template v-slot:status_text="{ record }">
              <a :href="'/order/channelOrder/chanelAfterSale/refund?refund_id='+record.refund_id" target="_blank">{{record.status_text}}</a>
            </template>
            <template v-slot:total_pay_price="{ record }">
              <p>￥{{record.total_pay_price}}<span v-if="$route.query.order_type == 'point'">+{{record.total_pay_point}}积分</span></p>
            </template>
          </a-table>
          <div class="s_flex_bian m-t-25">
            <div class="s_c333 "></div>
            <div class="s_c333 ">
              <p class="m-b-10">商品兑换积分：{{orderData.goods_point_price}}</p>
              <p class="m-b-10">实收积分: {{orderData.pay_point}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal title="订单备注" centered v-model:visible="showRemarks" :confirm-loading="confirmLoading" @ok="eidtRemarks" destroyOnClose>
      <a-textarea v-model:value="orderRemarks" placeholder="请输入订单备注内容" :rows="4" />
    </a-modal>
      <a-modal :title="deliverType == 1 ?'标记发货':'修改发货'" :width='1300' centered :footer="null" v-model:visible="showDeliver" destroyOnClose>
      <deliverForem :deliverData='deliverData' :type='deliverType' v-on:submitdeliver='submitdeliver'></deliverForem>
    </a-modal>
  </a-layout>
</template>

<script>
import { LeftOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import store from "@/store";
import {
  channelOrderRemarkUpdate,
  getChannelOrderDetail,
  channelOrderDelivery
} from "@/api/order";
import { iscode } from "@/utils/app";
export default {
  components: {
    LeftOutlined,
  },
  setup() {
    const state = reactive({
      showAddress: false,
      showDeliver: false,
      listLoading: false,
      showRemarks: false,
      addressData: {},
      deliverData: {},
      refundsData: {},
      orderRemarks: "",
      deliverType: 1,
      confirmLoading: false,
      info: store.state.user.info,
      orderData: {},
      allNum: 0,
      allWeight: 0,
    });
    let columnsGood = [
      {
        title: "商品",
        key: "good",
        slots: { customRender: "good" },
      },
      {
        title: "规格",
        dataIndex: "goods_sku_name",
        key: "goods_sku_name",
      },
      {
        title: "数量",
        dataIndex: "goods_num",
        key: "goods_num",
      },
      {
        title: "单价（积分）",
        dataIndex: "point_price",
        key: "point_price",
      },
      {
        title: "小计（积分）",
        dataIndex: "total_point_price",
        key: "total_point_price",
      },
      {
        title: "发货状态",
        dataIndex: "shipping_status_text",
        key: "shipping_status_text",
      },
      {
        title: "退款状态",
        dataIndex: "status_text",
        key: "status_text",
        slots: { customRender: "status_text" },
      },
    ];
    let columnsRecord = [
      {
        title: "操作时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作人",
        dataIndex: "user",
        key: "user",
        slots: { customRender: "user" },
      },
      {
        title: "操作动作",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "信息",
        dataIndex: "remark",
        key: "remark",
      },
    ];
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const _lodash = inject("_lodash");

    //获取备注
    const getRemarks = async (e) => {
        state.showRemarks = true;
        state.orderRemarks = state.orderData.bussiness_remark;
    };
    //修改备注
    const eidtRemarks = async () => {
      state.confirmLoading = true;
      let res = await channelOrderRemarkUpdate({
        order_no: $route.query.id,
        remark: state.orderRemarks,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.showRemarks = false;
        state.orderRemarks = "";
        message.success(res.msg);
        initData();
      } else {
        message.error(res.msg);
      }
      state.confirmLoading = false;
    };
    //获取订单地址
    const getAddress = async (e) => {
      let res = await channelOrderRemarkUpdate({ order_no: $route.query.id })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.showAddress = true;
        res.data[0].detail = res.data[0].detail.split(",")[1];
        state.addressData = res.data[0];
      } else {
        message.error(res.msg);
      }
    };
 

    //获取详情
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getChannelOrderDetail({ order_no: $route.query.id }).then(
        (res) => res.data
      );
      state.listLoading = false;
      if (iscode(res)) {
        state.orderData = res.data;
        console.log(state.orderData);
      } else {
        message.error(res.msg);
      }

      setTimeout(hide);
    };
        //打开发货弹窗
    const orderDeliver = (data,type) => {
      if(data.is_delivery == 0){
        message.error('订单中含有退款中商品，请处理！');
        return
      }
      state.deliverType = type;
      state.deliverData = data
      state.showDeliver = true;
    };
    //发货
    const submitdeliver =async (e) => {
   let result = await channelOrderDelivery({
        order_no: state.deliverData.order_sn,
        delivery_type: e.delivery_type,
        express_name: e.express_name,
        express_no: e.express_no,
        remark: e.store_remark,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
      state.showDeliver = false;
        initData();
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      columnsRecord,
      columnsGood,
      ...toRefs(state),
      eidtRemarks,
      getRemarks,
      getAddress,
      orderDeliver,
      submitdeliver,
      // goBack
    };
  },
};
</script>

